import {
  Typography,
  CardMedia,
  Box,
  Card,
} from "@mui/material";

export default function CreditCardDisplay({
  card,
  scale = 0.75,
}: {
  card?: {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
  };
  scale?: number;
}) {
  if (!card) return null;
  const { brand, last4, exp_month, exp_year } = card;

  return (
    <Card
      elevation={2}
      sx={{
        width: `calc(85.6mm * ${scale})`,
        height: `calc(53.98mm * ${scale})`,
        borderRadius: `calc(3mm * ${scale})`,
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(135deg, #e0e0e0 0%, #9e9e9e 100%)",
        color: "#fff",
        p: 0,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "85.6mm",
          height: "53.98mm",
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            position: "absolute",
            top: "56%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            m: 0,
            p: 0,
            fontFamily:
              'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
            letterSpacing: "0.15em",
            fontWeight: 600,
            textAlign: "center",
            color: "#fff",
            textShadow:
              "0 2px 3px rgba(0,0,0,0.45), 0 6px 12px rgba(0,0,0,0.35), 0 12px 24px rgba(0,0,0,0.25)",
            whiteSpace: "nowrap",
          }}
        >
          •••• •••• •••• {last4}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            position: "absolute",
            left: 16,
            bottom: 14,
            opacity: 0.95,
            fontWeight: 500,
            letterSpacing: "0.08em",
            fontSize: "1.25rem",
            color: "#fff",
            textShadow:
              "0 2px 3px rgba(0,0,0,0.45), 0 6px 12px rgba(0,0,0,0.35), 0 12px 24px rgba(0,0,0,0.25)",
          }}
        >
          {String(exp_month).padStart(2, "0")}/{String(exp_year % 100).padStart(2, "0")}
        </Typography>

        <CardMedia
          component="img"
          alt={`${brand} logo`}
          title="cc-logo"
          image={`/images/creditcard/${brand.toLowerCase().replace(/ /g, "-")}.png`}
          sx={{
            position: "absolute",
            right: 12,
            bottom: 8,
            height: "12mm",
            width: "auto",
            opacity: 0.9,
            filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.35))",
          }}
        />
      </Box>
    </Card>
  );
}

